<div class="modal-header">
    <div class="row w-100">
        <div class="col-md-11">
            <h5 class="modal-title">Add Document</h5>
        </div>
        <div class="col-md-1 pe-0">
            <button type="button" class="close float-end text-white pe-0" aria-label="Close"
                data-testid="modals.upload-document.close-btn"
                (click)="activeModal.dismiss()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
    </div>
</div>
<div class="modal-body" [ngClass]="{'opacity-5 cursor-none':flagObj.uploadDocumentLoader}">
    <form name="uploadDocForm" novalidate>
        <div class="form-group row">
            <div class="col-md-12 col-sm-12">
                <div class="upload-file-drop-zone" appDropfile (fileDropped)="onFileDropped($event)">
                    <div class="text-center mt-4 text-secondary pt-2" *ngIf="files.length==0">Drop Files</div>
                    <div *ngFor="let file of files ; let i = index" class="float-start">
                        <div class="filesList text-dark p-2">
                            <span>{{file.name}}</span>
                            <i class="fa fa-times crossIcon ps-1 cursor-pointer text-danger" aria-hidden="true"
                                [attr.data-testid]="'modals.upload-document.remove-file-btn-' + i"
                                role="button" tabindex="0" [attr.aria-label]="'Remove file ' + file.name"
                                (click)="removeFiles(i)"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group row">
            <div class="col-md-12 col-sm-12 no-padding-left-right">
                <div class="float-start me-2 font-14 text-secondary"><label>Attach Files</label></div>
                <label class="float-start padding paperClip cursor-pointer" aria-label="Attach files">
                    <input type="file" class="d-none" ng-model="uploadFile" id="fileUpload" name="uploadFile"
                        multiple="multiple" (change)="getFileDetails($event)"
                        aria-label="Choose files to upload"
                        data-testid="modals.upload-document.file-input" />
                    <i class="fa fa-paperclip font-14 color-brown" aria-hidden="true"></i>
                </label>
            </div>
            <div *ngIf="flagObj.uploadDocFormSubmitted && flagObj.showUploadError" class="text-danger ms-1">Please attach a file.</div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-link" data-testid="modals.upload-document.cancel-btn" (click)="closeModal('close')" [disabled]="flagObj.disableBtn">
        CANCEL
    </button>
    <button type="button" class="btn btn-primary btn-sm rounded-pill" data-testid="modals.upload-document.save-btn" (click)="saveDocument()" [disabled]="flagObj.disableBtn">
        Add Document &nbsp;&nbsp;<span class="loader spinner-border spinner-border-sm" *ngIf="flagObj.uploadDocumentLoader"></span>
    </button>
</div>
